import React from "react";
import FlexContainer from "common/ui/containers/flexContainer/FlexContainer";
import FlexItem from "common/ui/containers/flexContainer/FlexItem";
//--
import styles from "./PageHeading.less";
//--
const PageHeading = ({ reportName, datePicker, children }) => {
    return (React.createElement("div", { className: styles.headerBar },
        React.createElement(FlexContainer, { className: styles.heading },
            React.createElement(FlexItem, null,
                React.createElement("span", { className: styles.reportTitle }, reportName)),
            React.createElement(FlexItem, { className: styles.centerContents }, datePicker && datePicker),
            React.createElement(FlexItem, { className: styles.headerContents }, children))));
};
export default PageHeading;
